module.exports = __webpack_public_path__ + "static/media/pin_off_icon.01e99049.svg";